import React, { useState } from "react";
import { createUseStyles, useTheme } from "react-jss";
import { useImmer } from "use-immer";
import { TeamMode } from "engage-common/types";
import DisplayText, { TextVariant } from "../DisplayText";
import RadioGroup, { Radio } from "../RadioGroup";
import Button from "../Button";
import { CreateState } from "../../pages/host";
import TrashcanIcon from "../icons/TrashcanIcon";
export var DefaultTeamExplanation = "During this game, your points will go toward a group score to determine the winning team.";
function initialTeamState(teamInfos, teams) {
    var state = [];
    var _loop_1 = function (key) {
        var team = teams === null || teams === void 0 ? void 0 : teams.find(function (t) { return t.key === key; });
        if (team) {
            state.push({
                key: key,
                name: team.name,
                added: true
            });
        }
        else {
            state.push({
                key: key,
                name: "",
                added: false
            });
        }
    };
    for (var _i = 0, _a = Object.keys(teamInfos); _i < _a.length; _i++) {
        var key = _a[_i];
        _loop_1(key);
    }
    return state;
}
var useStyles = createUseStyles(function (theme) { return ({
    teams: {
        flex: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: theme.color.background.main,
    },
    content: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: 840,
    },
    assignOptions: {
        alignSelf: "stretch",
        marginTop: 40
    },
    addTeamContainer: {
        display: "flex",
        flexWrap: "wrap"
    },
    explanationLabel: {
        marginTop: 30,
        marginLeft: 10,
        alignSelf: "flex-start"
    },
    explanation: {
        margin: [10, 10, 30],
        alignSelf: "stretch",
        height: 150,
        backgroundColor: "#D2DAE0",
        border: "none",
        borderBottom: "1px solid ".concat(theme.color.primary.main),
        fontFamily: '"Anova", "Roboto", "Helvetica", "Arial", "sans-serif"',
        fontSize: 20,
        fontWeight: 400,
        padding: 10,
        color: theme.color.primary.main,
        resize: "none",
    },
    buttonContainer: {
        marginTop: 50,
    },
    button: {
        margin: [0, 10],
        width: 180
    },
}); });
export default function CreateTeams(_a) {
    var _b;
    var formValues = _a.formValues, setState = _a.setState, setFormValue = _a.setFormValue;
    var classes = useStyles();
    var theme = useTheme();
    var _c = useImmer(initialTeamState(theme.teamInfos, formValues.teams)), teamState = _c[0], setTeamState = _c[1];
    var _d = useState(function () {
        if (formValues.teamMode && formValues.teamMode !== TeamMode.Off) {
            return formValues.teamMode;
        }
        return TeamMode.Choose;
    }), teamAssign = _d[0], setTeamAssign = _d[1];
    var _e = useState((_b = formValues.teamExplanation) !== null && _b !== void 0 ? _b : ""), teamExplanation = _e[0], setTeamExplanation = _e[1];
    var teamButtons = [];
    for (var i = 0; i < teamState.length; i++) {
        teamButtons.push(React.createElement(AddTeam, { key: i, index: i, teamState: teamState[i], setTeamState: setTeamState, teamInfos: theme.teamInfos }));
    }
    var onDone = function () {
        var _a;
        var error = "";
        var savedTeams = [];
        for (var _i = 0, teamState_1 = teamState; _i < teamState_1.length; _i++) {
            var team = teamState_1[_i];
            if (team.added) {
                var teamInfo = theme.teamInfos[team.key];
                if ((_a = team.name) === null || _a === void 0 ? void 0 : _a.trim().length) {
                    savedTeams.push(team);
                }
                else {
                    error = "The ".concat(teamInfo.name.toUpperCase(), " team needs a name!");
                    break;
                }
            }
        }
        if (error === null || error === void 0 ? void 0 : error.length) {
            window.alert(error);
        }
        else if (savedTeams.length < 2) {
            window.alert("You need at least two teams to have a Team event.");
        }
        else {
            setFormValue("teamMode", teamAssign);
            setFormValue("teams", savedTeams);
            setFormValue("teamExplanation", teamExplanation);
            setState(CreateState.main);
        }
    };
    var onCancel = function () {
        var _a;
        if ((_a = formValues.teams) === null || _a === void 0 ? void 0 : _a.length) {
            if (window.confirm("Are you sure you want to remove teams?")) {
                //Reset all the teams settings
                setFormValue("teamMode", TeamMode.Off);
                setFormValue("teamExplanation", undefined);
                setFormValue("teams", undefined);
                setState(CreateState.main);
            }
        }
        else {
            //We didn't have any team settings saved, so we can just reset the component
            setFormValue("teamMode", TeamMode.Off);
            setState(CreateState.main);
        }
    };
    return (React.createElement("div", { className: classes.teams },
        React.createElement("div", { className: classes.content },
            React.createElement(DisplayText, { variant: TextVariant.s40black, fontWeight: 400, color: "primary" }, "Team Settings"),
            React.createElement(RadioGroup, { name: "teamAssign", value: teamAssign, horizontal: true, className: classes.assignOptions, onChange: function (e) { return setTeamAssign(e.target.value); } },
                React.createElement(Radio, { value: TeamMode.Choose, labelText: "Player chooses their team" }),
                React.createElement(Radio, { value: TeamMode.Random, labelText: "Randomly assign a team" })),
            React.createElement(DisplayText, { variant: TextVariant.s16reg, color: "primary", className: classes.explanationLabel }, "Tell the players why they're selecting a team, or leave blank for the default below."),
            React.createElement("textarea", { className: classes.explanation, placeholder: DefaultTeamExplanation, value: teamExplanation, onChange: function (e) { return setTeamExplanation(e.target.value); } }),
            React.createElement("div", { className: classes.addTeamContainer }, teamButtons),
            React.createElement("div", { className: classes.buttonContainer },
                React.createElement(Button, { className: classes.button, backgroundColor: "secondary", onClick: onCancel }, formValues.teams ? "Remove Teams" : "Cancel"),
                React.createElement(Button, { className: classes.button, onClick: onDone }, "Done")))));
}
;
var useAddTeamStyles = createUseStyles({
    addTeamWrapper: {
        flexBasis: "50%",
        padding: 10,
        height: 102,
    },
    addTeam: {
        padding: 30,
        width: "100%",
        background: function (props) { return props.background; },
        border: function (props) { return "1px dashed ".concat(props.border); },
        userSelect: "none",
        cursor: "pointer",
        "&:focus": {
            outline: "none",
            border: function (props) { return "1px solid ".concat(props.border); },
        },
    },
    teamNameWrapper: {
        height: "100%",
        background: function (props) { return props.background; },
        borderBottom: function (props) { return "1px solid ".concat(props.border); },
        display: "flex",
        alignItems: "center",
        padding: 20,
    },
    nameField: {
        background: "none",
        border: "none",
        flex: 1,
        margin: 10,
        fontFamily: '"Anova", "Roboto", "Helvetica", "Arial", "sans-serif"',
        fontSize: 20,
        fontWeight: 400,
        "&:focus": {
            outline: "none",
        },
    },
    trashWrapper: {
        border: function (props) { return "1px dashed ".concat(props.border); },
        borderRadius: "50%",
        width: 42,
        height: 42,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "none",
        cursor: "pointer",
        "&:focus": {
            outline: "none",
            border: function (props) { return "2px solid ".concat(props.border); },
        },
    }
});
function AddTeam(_a) {
    var index = _a.index, teamState = _a.teamState, setTeamState = _a.setTeamState, teamInfos = _a.teamInfos;
    var teamInfo = teamInfos[teamState.key];
    var classes = useAddTeamStyles({ border: teamInfo.main, background: teamInfo.lightBG });
    var addTeam = function () {
        setTeamState(function (stateDraft) {
            stateDraft[index] = {
                key: teamState.key,
                name: "",
                added: true
            };
        });
    };
    var teamNameChanged = function (e) {
        var newName = e.target.value;
        setTeamState(function (stateDraft) {
            stateDraft[index] = {
                key: teamState.key,
                name: newName,
                added: true
            };
        });
    };
    var deleteTeam = function () {
        setTeamState(function (stateDraft) {
            stateDraft[index] = {
                key: teamState.key,
                name: "",
                added: false
            };
        });
    };
    return (React.createElement("div", { className: classes.addTeamWrapper }, teamState.added ?
        React.createElement("div", { className: classes.teamNameWrapper },
            React.createElement("input", { type: "text", className: classes.nameField, placeholder: "Enter the ".concat(teamInfo.name.toUpperCase(), " Team Name*"), value: teamState.name, onChange: teamNameChanged, autoFocus: true, maxLength: 20 }),
            React.createElement("button", { className: classes.trashWrapper, onClick: deleteTeam },
                React.createElement(TrashcanIcon, { color: teamInfo.main })))
        :
            React.createElement("button", { className: classes.addTeam, onClick: addTeam },
                React.createElement(DisplayText, { variant: TextVariant.s20med },
                    "+ Add the ",
                    teamInfo.name.toUpperCase(),
                    " Team"))));
}
//# sourceMappingURL=CreateTeams.js.map